export type Type =
    | 'Домашняя работа'
    | 'Классная работа'
    | 'Контрольная работа'
    | 'Экзамен';

export enum PointTypeColor {
    'Домашняя работа' = '#79C294',
    'Классная работа' = '#C5A06A',
    'Контрольная работа' = '#6A7EC5',
    'Экзамен' = '#CF4E4E',
}

export interface IPoint {
    point: number;
    date: string;
    theme: string;
    comment?: string;
    type: Type;
}

interface IMeanPoint {
    point: number;
    month: string;
}

export interface IProgressData {
    curMeanPoint: number;
    prevMeanPoints: IMeanPoint[];
    lastPoints: IPoint[];
    chartPoints: IPoint[];
    startYear: number;
}

export interface IProgressState {
    data: IProgressData;
    isLoading: boolean;
    hasLoaded: boolean;
    hasToastShown: boolean;
}
